import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { RouteApplicationStartupResolveService } from '../../core/route-application-startup-resolve.service';
import { TransactionShellComponent } from './transaction-shell/transaction-shell.component';
import { TransactionLookupResolveService } from './shared/services/transaction-lookup-resolve.service';

const transactionsRoutes: Routes = [
  {
    path: 'billing/transactions',
    component: TransactionShellComponent,
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: TransactionLookupResolveService,
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        component: TransactionListComponent,
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(transactionsRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class TransactionsRoutingModule {}
